/**
 * @desc 根据店铺编号和站点标识获取店铺
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformSiteShopResponseDto>;
export function request(
  params: API.basics.platformSiteShopFacadeImpl.getByShopNoAndSiteKey.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getByShopNoAndSiteKey`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
